/* hs-eslint ignored failing-rules */

import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { fetchScopeStatus } from '../api/accountVerification';
import SuspensionBannersContext from '../contexts/suspensionBannersContext';
import useBanner from '../hooks/useBanner';
import { sourceAppValues } from '../types';
import Banner from './Banner';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const AccountVerificationContextBanner = ({
  scope,
  source
}) => {
  const [fetchFinished, setFinishedFetching] = useState(false);
  const {
    statusFor,
    setStatusFor,
    bannerHiddenByUserFor,
    setBannerHiddenByUserFor
  } = useContext(SuspensionBannersContext);
  const {
    showBanner,
    showCta,
    alertType,
    langPath,
    closable
  } = useBanner(bannerHiddenByUserFor(scope), statusFor(scope));
  useEffect(() => {
    if (scope) {
      fetchScopeStatus(scope).then(status => setStatusFor(scope)(status)).catch(console.error).finally(() => setFinishedFetching(true));
    }
  }, [scope]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (fetchFinished && !closable) {
      setBannerHiddenByUserFor(scope)(false);
    }
  }, [fetchFinished, closable]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!showBanner) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(Banner, {
    source: source,
    alertType: alertType,
    showCta: showCta,
    langPath: langPath,
    closable: closable,
    onClose: () => setBannerHiddenByUserFor(scope)(true)
  });
};
AccountVerificationContextBanner.propTypes = {
  scope: PropTypes.string.isRequired,
  source: PropTypes.oneOf(sourceAppValues).isRequired
};
export default AccountVerificationContextBanner;